import axios from "axios";
import { API_URL } from "../common/constants";
import * as types from "./types";

export const createFpzReport = async (params) => {
  const url = `${API_URL}/fpz/create`;
  try {
    console.log('Create fpz report:', url, params);
    const response = await axios.post(url, params);

    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to create report', response);
      return [];
    }

  } catch (error) {
    console.error('Error creating report:', url, error);
    return [];
  }
};

export const updateFpzReport = async (params) => {
  const url = `${API_URL}/fpz/update/${params.fpz_report_id}`;
  try {
    console.log('Update fpz report:', url, params);
    const response = await axios.post(url, params);
    console.log('Update fpz report response:', response);
    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to update report', response);
      return [];
    }

  } catch (error) {
    console.error('Error updating report:', url, error);
    return [];
  }
};

export const getFpzReports = async (params) => {
  const url = `${API_URL}/fpz/list`;
  try {
    console.log('List fpz reports:', url, params);
    const response = await axios.post(url, params);

    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to get reports', response);
      return [];
    }

  } catch (error) {
    console.error('Error getting reports:', url, error);
    return [];
  }
};

export const getFpzReport = async (fpzReportId) => {
  const url = `${API_URL}/fpz/find/${fpzReportId}`;
  try {
    console.log('List fpz reports:', url, fpzReportId);
    const response = await axios.get(url);

    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to get report', response);
      return [];
    }

  } catch (error) {
    console.error('Error getting report:', url, error);
    return [];
  }
};

export const getFpzFoldersAndReports = async (params) => {
  const url = `${API_URL}/fpz/list/folders`;
  try {
    console.log('List fpz folders & reports:', url, params);
    const response = await axios.post(url, params);
    console.log('List fpz folders & reports response:', response);
    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to get folders & reports', response);
      return [];
    }

  } catch (error) {
    console.error('Error getting  folders & reports:', url, error);
    return [];
  }
};

export const uploadReportImages = async (params) => {
  const url = `${API_URL}/fpz/store/images`;
  try {
    console.log('Create fpz report:', url, params);
    const response = await axios.post(url, params);

    if (response.data) {
      return response.data;
    } else {
      console.error('Failed to create report', response);
      return [];
    }

  } catch (error) {
    console.error('Error creating report:', url, error);
    return [];
  }
};
